export function getParentSurveys(state) {
  return state.parent_surveys
}